import imageCompression from "browser-image-compression";
import { ErrorLogger } from "./Logger";

const toJpegFile = (compressedFile: Blob, originalFile: File): File => {
    const nameWithoutExtension = originalFile.name.replace(/\.[^/.]+$/, "");
    return new File([compressedFile], `${nameWithoutExtension || "image"}.jpg`, {
        type: "image/jpeg",
        lastModified: originalFile.lastModified,
    });
};

export const compressImage = async (file: File, maxSizeInMB: number = 1, initialQuality = 0.5): Promise<File> => {
    try {
        const options = {
            maxSizeMB: maxSizeInMB,
            maxWidthOrHeight: 1920,
            useWebWorker: true,
            fileType: "image/jpeg",
            initialQuality,
        };

        const compressedFile = await imageCompression(file, options);
        return toJpegFile(compressedFile, file);
    } catch (err) {
        ErrorLogger.log(err, 'compressImage');
        throw err;
    }
}


export const compressMultipleImages = async (files: File[], maxSizeInMB: number = 1, initialQuality = 0.5): Promise<File[]> => {
    try {
        const options = {
            maxSizeMB: maxSizeInMB,
            maxWidthOrHeight: 1920,
            useWebWorker: true,
            fileType: "image/jpeg",
            initialQuality,
        };

        let compressedFiles: File[] = []
        for (const file of files) {
            const compressedFile = await imageCompression(file, options)  
            compressedFiles.push(toJpegFile(compressedFile, file))
        }

        return compressedFiles

    } catch (err) {
        ErrorLogger.log(err, 'compressMultipleImages');
        throw err;
    }
}